import { createContext, useContext } from 'react';

import type { SessionKind } from '../api/SessionKind';

import type { SessionProfile } from './SessionProfile';

export type SessionState = {
  profile: SessionProfile | null;
  isLoading: boolean;
  /** A failure to read the profile that is not a rejected session — the API unreachable, typically. */
  error: unknown;
  retry: () => void;
  signIn: (kind: SessionKind, email: string, password: string) => Promise<void>;
  signOut: () => Promise<void>;
};

export const SessionContext = createContext<SessionState>({
  profile: null,
  isLoading: true,
  error: null,
  retry: () => undefined,
  signIn: async () => undefined,
  signOut: async () => undefined,
});

export const useSession = (): SessionState => useContext(SessionContext);
